import React, { useEffect, useMemo } from "react";
import ReactGA from "react-ga4";

import "./App.css";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { useAtom } from "jotai";
import {
  fieldObjectsAtom,
  currentFieldsAtom,
  outputAtom,
  currentIndexAtom,
  fieldsActionAtom,
  currentIdAtom,
  fieldObjectsActionAtom,
} from "./state/global.state";
import { Navigations } from "./components/Navigations";
import { Buttons } from "./components/Buttons";
import { Fields } from "./components/Fields";
import type { FieldObject } from "./types/fieldObject";
import { initial_fieldObjects } from "./const/initial.state";
import { Buymeacoffee } from "./components/Buymeacoffee";

function App() {
  // Google Analytics 測定 ID を入力して設定
  ReactGA.initialize("G-PH80EDSLCZ");
  // ページビューイベントを処理
  ReactGA.send("pageview");

  const [output] = useAtom(outputAtom);
  const [fieldsAction] = useAtom(fieldsActionAtom);
  const [fieldObjectsAction] = useAtom(fieldObjectsActionAtom);
  const [fieldObjects, setFieldObjects] = useAtom(fieldObjectsAtom);
  const [currentFields, setCurrentFields] = useAtom(currentFieldsAtom);
  const [currentIndex, setCurrentIndex] = useAtom(currentIndexAtom);
  const [currentId, setCurrentId] = useAtom(currentIdAtom);

  if (!fieldObjects || fieldObjects.length == 0 || fieldObjects[0].fields.length == 0) {
    setFieldObjects(initial_fieldObjects);
  }
  useEffect(() => {
    if (fieldObjects.length > 0) {
      fieldObjects !== initial_fieldObjects && setFieldObjects(() => fieldObjects);
    }
    if (fieldObjects.length > 0 && !fieldObjects[currentIndex]) {
      // init
      setCurrentId(fieldObjects[0].id);
      setCurrentIndex(0);
    }
  }, [fieldObjectsAction]);

  useEffect(() => {
    // merge currentFields to fieldObjects
    if (fieldObjects.length > 0 && currentFields.length > 0) {
      const newFieldObjects = [...fieldObjects];
      newFieldObjects[currentIndex].fields = currentFields;
      setFieldObjects(() => newFieldObjects);
    }
  }, [fieldsAction]);

  useEffect(() => {
    // change current fields
    if (fieldObjects.length > 0) {
      const filteredFieldObjects = fieldObjects.filter((object: FieldObject) => {
        return object.id == currentId;
      });
      filteredFieldObjects.length > 0 && setCurrentFields(() => filteredFieldObjects[0].fields);
    }
  }, [currentId, currentIndex]);

  useEffect(() => {
    // fix currentIndex when navigation order is changed
    if (fieldObjects.length > 0 && fieldObjects[currentIndex].id !== currentId) {
      const newIndex = fieldObjects
        .map((filterObject, index) => (filterObject.id == currentId ? index : false))
        .filter((index) => index !== false)[0];
      if (typeof newIndex == "number") {
        setCurrentIndex(newIndex);
      }
    }
  }, [fieldObjects]);

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const nav_element = document.querySelector<HTMLElement>("#nav-container > div")!;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const list_element = document.querySelector<HTMLElement>("#list-container > div")!;
    if (nav_element || list_element) {
      nav_element.style.display = "flex";
      nav_element.style.gap = "8px";
      list_element.style.display = "flex";
      list_element.style.gap = "20px";
    }
  }, []);

  const BuymeacoffeeMemo = useMemo(() => {
    return <Buymeacoffee />;
  }, []);
  return (
    <div className="App bg-gray-100 min-h-screen flex flex-col">
      <Header />
      {/* <div className="flex flex-col"> */}
      {/* <p>currentId: {currentId}</p> */}
      {/* <p>currentIndex: {currentIndex}</p> */}
      {/* <p>currentName: {fieldObjects.length > 0 && fieldObjects[currentIndex].name}</p> */}
      {/* <p>fieldObjects: {JSON.stringify(fieldObjects)}</p> */}
      {/* <p>currentFields: {fieldObjects.length > 0 && JSON.stringify(fieldObjects[currentIndex].fields)}</p>
        <p>currentFields: {JSON.stringify(currentFields)}</p> */}
      {/* </div> */}
      <div className="flex flex-col gap-5 overflow-hidden pb-10">
        <Navigations />
        <div className="flex flex-nowrap px-5 pt-5 pb-4 -mt-2 -mb-2 flex-col gap-5 max-w-[1280px] mx-auto w-full overflow-x-auto">
          <Fields />
        </div>
        <div className="flex flex-nowrap  px-5  flex-col gap-5 max-w-[1280px] mx-auto w-full">
          <Buttons />
        </div>
        <div className="flex flex-nowrap  px-5  flex-col gap-5 max-w-[1280px] mx-auto w-full">
          <textarea
            readOnly
            className="textarea textarea-bordered min-h-[200px] w-full"
            placeholder="output text"
            id="output"
            name="output"
            value={output}
          ></textarea>
        </div>
      </div>
      <Footer />
      {BuymeacoffeeMemo}
    </div>
  );
}

export default App;
